import { useCallback, useEffect, useRef, useState } from "react";

type TokenResponse = {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  error?: string;
  error_description?: string;
};

const clientId =
  "104170281829-f5j0cc06c53jrev0qms0i4kn6ksheqc7.apps.googleusercontent.com";
export function useGoogleSheetsAuth(scope: string) {
  const tokenClientRef = useRef<any>(null);
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let t: any;

    const init = () => {
      if (!window.google?.accounts?.oauth2) return;

      tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope,
        callback: (resp: TokenResponse) => {
          if (resp.error) {
            setError(resp.error_description || resp.error);
            return;
          }
          setError(null);
          setAccessToken(resp.access_token);
        },
      });

      setReady(true);
    };

    // script async: poll sampai available (simple & reliable)
    t = setInterval(() => {
      if (window.google?.accounts?.oauth2) {
        clearInterval(t);
        init();
      }
    }, 100);

    return () => clearInterval(t);
  }, [clientId, scope]);

  const requestToken = useCallback((prompt: "consent" | "" = "consent") => {
    setError(null);
    if (!tokenClientRef.current) {
      setError("GIS not initialized yet.");
      return;
    }
    tokenClientRef.current.requestAccessToken({ prompt });
  }, []);

  const logout = useCallback(() => {
    setAccessToken(null);
  }, []);

  return { ready, accessToken, error, requestToken, logout };
}
